<mm-spinner [loading]="isTemplatesTab ? showSpinner$ : tableState$"></mm-spinner>
<div class='errorMsgContainer' *ngIf="(tableState$ | async)?.hasError">
    <div class='documentWarning-icon'></div>
    <div class='main-msg'>Can't load transactions</div>
    <div class='secondary-msg'>Sorry for the inconvenience.<br>Please try again.</div>
  <a (click)="refreshAccount(accountId)" class='refresh-msg'>Refresh page</a>
</div>
<ng-template
    [ngIf]="!(tableState$ | async)?.hasError && (tableState$ | async)?.isInitialLoad && !(tableState$ | async)?.loading">
    <div class='errorMsgContainer'>
        <div class='documentWarning-icon'></div>
        <div class='main-msg'>View {{tableItemInContext}}</div>
        <div class='secondary-msg'>Select an account and the<br>
            corresponding {{tableItemInContext}} will show up here.</div>
    </div>
</ng-template>
<ng-template
    [ngIf]="!(tableState$ | async)?.hasError && (tableState$ | async)?.hasEmptyResponse && !(tableState$ | async)?.loading">
    <div class='errorMsgContainer'>
      <div class='main-msg' *ngIf="!isTemplatesTab && !params.noRowsMessageFn().isBookmarkFilterApplied">{{noRowsMessageTemplates.transactionsHeader}}</div>
      <div class='main-msg' *ngIf="params.noRowsMessageFn().isBookmarkFilterApplied">{{noRowsMessageTemplates.bookmarks}}</div>
    </div>
</ng-template>
